import {orderBy, pick} from 'lodash'
import React from 'react'
import Modal from 'react-modal'
import TabBar from './tab-bar'
import Text from 'react-text'
import {Context} from '../../context'
import GroupsStep from './groups-step'
import RegularDateStep from './date-step'
import AssessmentDateStep from './AssessmentDateStep'
import {editSchedule, editAssessmentSchedule} from '../../context/post'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import './schedule-lesson.styl'

function Buttons ({left, right}) {
  return (
    <div className="buttons" style={{display: "flex"}}>
      <div style={{flexGrow: 1}} />
      <button disabled={!left.enabled} className={left.label} onClick={left.onClick}>
        <Text id={`${left.label}_label`} />
      </button>
      <button disabled={!right.enabled} className={right.label} onClick={right.onClick}>
        <Text id={`${right.label}_label`} />
      </button>
    </div>
  )
}

export default class EditSchedule extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      date: props.date || new Date(),
      start: props.start || new Date(),
      finish: props.finish || new Date(),
      maxTime: props.content.max_time || 3600,
      message: props.message || "",
      activeTab: props.activeTab,
      selectedGroup: props.selectedGroup,
      studentList: props.studentList || [],
      selectedStudents: props.selectedStudents || [],
      isOpen: true,
      setState
    }
  }


  render () {

    const context = this.context
    const {setState, activeTab, isOpen} = this.state
    const {title, content = {}} = this.props

    const previous = () => setState({activeTab: 'groups'})
    const next = () => setState({activeTab: 'date'})
    const close = () => setState({isOpen: false})
    const navigateOut = () => context.navigate({}, context.match.path.replace(/\/:action.*$/,''), {preserveQuery: true})

    const isRegularEvent = !content.assessment_assignment

    const saveSchedule = () => {
      return editSchedule({
        content: this.props.content,
        language: context.languageId,
        event: this.context.event,
        students: this.state.selectedStudents,
        action: context.action,
        date: this.state.date,
        message: this.state.message,
        group: this.state.selectedGroup
      }).then(close)
    }

    const saveScheduleAssessment = () => {
      return editAssessmentSchedule({
        title: this.props.eventTitle,
        content: this.props.content,
        language: context.languageId,
        event: this.context.event,
        students: this.state.selectedStudents,
        action: context.action,
        start: this.state.start,
        finish: this.state.finish,
        maxTime: this.state.maxTime,
        message: this.state.message,
        group: this.state.selectedGroup
      }).then(close)
    }

    const save = isRegularEvent ? saveSchedule : saveScheduleAssessment

    const DateStep = isRegularEvent ? RegularDateStep : AssessmentDateStep

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="schedule-lesson-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="schedule-lesson">
            <div className="title">
              <div className="label">
                {title}
              </div>
              <div className="close" onClick={() => close()}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </div>
            </div>
            <TabBar {...{activeTab, setState}} />
            <div className="tab-content">
              {activeTab == 'groups' && (
                <React.Fragment>
                  <GroupsStep {...pick(this.state, ['selectedGroup', 'studentList', 'selectedStudents', 'setState'])} />
                  <Buttons
                    left={{label: 'cancel', onClick: close, enabled: true}}
                    right={{label: 'continue', onClick: next, enabled: true}}
                  />
                </React.Fragment>
              )}
              {activeTab == 'date' && (
                <React.Fragment>
                  <DateStep {...pick(this.state, ['start', 'finish', 'maxTime', 'date', 'setState', 'message'])} />
                  <Buttons
                    left={{label: 'back', onClick: previous, enabled: true}}
                    right={{label: 'save', onClick: save, enabled: this.state.selectedStudents.length > 0}}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
        </Modal>
    )
  }
}
